<template>
    <div>
        <!-- min-width: 520px;280px style="width:100%;height:100%;"-->
        <div style="box-size:border-box">
            <div id="main1" style="width:100%;height:240px"></div>
        </div>
  </div>
</template>

<script>
  
  import libs from '../../utils/libs'
  import store from "../../utils/storage";
  import echarts from 'echarts';
 
  import { getBaseUrl,GetTrainKpi} from "../../api/api";
  import { from } from 'linq';

  export default {
    data() {
      return {
        params: {
        TrainerId: 0,
        BeginDate: "",
        EndDate: "",
        College: "",
        Branch: "",
        SearchKey: "",
        Type: 2,
      },
      dataList:[],
      seriesList:[],
      DsTrainTypeList:[],
      DsRegionList:[],
      proportion2:[],
        hostUrl: getBaseUrl(),
        uploadHeaders: { 'Jwt-Token': store.getToken() },
        curUser: store.getUserInfo(),
        colors:  [["#4a7fb0", "#adc6e5", "#96bfee"],
        ["#2f75b5", "#5b9bd5", "#adc6e5"]],
        
        // dataList:[120, 150, 140, 148], //获取数据
      };
    },
    watch:{
     
    },
    mounted() {
      this.search(); 
    },
    methods: {
      // get(){
      // //  this.dataList = [];
      // },
      search() {
      this.chartLoading = true;
      // GetTrainKpi(this.params).then();
      GetTrainKpi(this.params).then((res) => {
        if (res.data.Code != 1) return;
        this.dataList = res.data.Data;
        this.seriesList=[];
        this.DsTrainTypeList =[];
        this.DsRegionList =[];
        this.proportion2=[];
        this.dataList.forEach(e=>{
          if(this.DsTrainTypeList.indexOf(e.TrainType)<0)
          {
              this.DsTrainTypeList.push(e.TrainType);
          }
          if(this.DsRegionList.indexOf(e.Region)<0)
          {
              this.DsRegionList.push(e.Region);
          }
          //this.seriesList.push({name:e.TrainType,type: "bar",data:[e.Value],label:{show:true}}) 
        })
        this.DsTrainTypeList.forEach(e=>{
          
            var arrDt=new Array(this.DsRegionList.length);
            var iCounts=0;
            this.dataList.forEach(k=>{
              if(k.TrainType==e)
              {
                arrDt[this.DsRegionList.indexOf(k.Region)]=k.Value;
                iCounts+=k.Value;
              }
            })
            this.seriesList.push({name:e,type: "bar",stack:"1",barGap: '-100%',data:arrDt,label:{show:true}})
            this.proportion2.push({value: iCounts, name: e });
        } 
        )
        setTimeout(() => {
          this.initChart();
          // this.myChart2();
          this.chartLoading = false;
        }, 100);
      });
    },
      initChart(){
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('main1'));
        var option = {
          backgroundColor: "transparent",//#344b58
          color:this.colors[0],
          title: {
            text: "数据总览",
            left: 'center',
            // top:10,
            bottom:20,
            textStyle: {
              color: '#000',
              fontSize: '16'
            },
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
            // toolbox: {
            //   feature: {
            //     dataView: {show: true, readOnly: false},
            //     magicType: {show: true, type: ['line', 'bar']},
            //     restore: {show: true},
            //     saveAsImage: {show: true}
            //   }
            // },
          grid: {
            borderWidth: 0,
            top: "12%",
            left:'8%',
            // bottom:0,
            height:'62%',
            width: "85%",
            textStyle: {
                color: "#fff"
            },
            containLabel: true,
          },
          calculable: true,
          xAxis: [{
            type: 'category',
              data:this.DsRegionList,
            //  data: ['协防辅导','日常办公','出差在途','测评补考','业务会议','大学会议','TTT','课程认证','课程演练','工作坊','课程培训','业务项目','工作调休','法定休假'],
            axisPointer: {
                type: 'shadow'
            },
             axisLabel: {
              interval:0, //坐标刻度之间的显示间隔，默认就可以了（默认是不重叠）
              rotate:30,   //调整数值改变倾斜的幅度（范围-90到90）
              formatter: function (value) {
                return  value.substring(0,5)
              }
            }
          }],
          yAxis: [{
            type: 'value',
            name: '场次',
            min: 0,
            axisLabel: {
              formatter: '{value}'
            }
          }],
          // series: [{
          //   name: '培训场次',
          //   type: 'bar',
          //   data: this.dataList,
          //   barWidth:30,
          //   label: {
          //     show: true
          //   },
          // }]
          series: this.seriesList,
        }
        myChart.setOption(option);
      },

    }
  };
</script>

<style lang="less" scoped>
  @import "../../assets/css/list.css";
  .item1{
    display: block;
  }
  
  .item2{
    display: block;
    margin-top: 10px;
  }
  /deep/ .el-input--mini .el-input__inner{
    height: 28px!important;
  }
  /deep/ .el-cascader__tags{
    flex-wrap: inherit;
  }
//   /deep/ .el-form--inline .el-form-item{
//       display: block;
//   }

</style>


// WEBPACK FOOTER //
// src/components/public/HomeEcharts1.vue